import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.sass'],
})
export class IconComponent implements OnInit {
  @Input() name: string;
  @Input() ariaLabel: string;
  @Input() isSmall: boolean;

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.ariaLabel = this.ariaLabel || `Icon ${this.name}`;
    this.iconRegistry.addSvgIcon(
      this.name,
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `assets/icons/${this.name}.svg`
      )
    );
  }
}
